import { Text, Center } from "@chakra-ui/react";
import { Outlet, redirect } from "react-router";
import { createBrowserRouter } from "react-router-dom";

export const Root = () => <Outlet />;

// ブラウザの言語設定に応じて "ja" か "en" を返す
export const getPreferredLanguage = (language: string = navigator.language) =>
  language.toLowerCase().startsWith("ja") ? "ja" : "en";

// 言語が指定されていないURLからトップページへリダイレクトする
export const redirectToLocalizedTop = () =>
  redirect(`/top/${getPreferredLanguage()}`);

const ErrorBoundary = () => (
  <Center>
    <Text>エラーが発生しました</Text>
  </Center>
);
const NotFoundPage = () => (
  <Center>
    <Text>お探しのページは存在しません</Text>
  </Center>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      // "/" と "/top" へのアクセス時は言語設定に応じて "/top/ja" か "/top/en" へリダイレクト
      {
        index: true,
        loader: redirectToLocalizedTop,
      },
      {
        path: "/top",
        loader: redirectToLocalizedTop,
      },
      {
        path: "/top/:lng",
        async lazy() {
          try {
            const { Top } = await import("./pages/Top");
            return { Component: Top };
          } catch (_) {
            window.location.reload();
          }
          return { Component: NotFoundPage };
        },
      },
    ],
  },
  {
    path: "/privacy_policy/:lng",
    async lazy() {
      try {
        const { PrivacyPolicy } = await import("./pages/PrivacyPolicy");
        return { Component: PrivacyPolicy };
      } catch (_) {
        window.location.reload();
      }
      return { Component: NotFoundPage };
    },
  },
  {
    path: "/conditions/:lng",
    async lazy() {
      try {
        const { Conditions } = await import("./pages/Conditions");
        return { Component: Conditions };
      } catch (_) {
        window.location.reload();
      }
      return { Component: NotFoundPage };
    },
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

